<template>
    <div class="sw-width-full">
        <div id="sw-anchor"></div>
        <template v-for="(component,index) in surveyForm.form_components">
            <div v-show="currentStep === index">
                <div v-if="surveyForm.form_components.length > 1" class="progressbar sw-container">
                    <step-progress :steps="Array.from({length: surveyForm.form_components.length}, (_, i) => i + 1)"
                                   :current-step="currentStep"
                                   icon-class="fa fa-check"
                                   :active-color="'#00ae8f'"
                                   :line-thickness="1"
                                   :active-thickness="1"
                                   :passive-thickness="1"
                                   class="sw-steps-color"></step-progress>
                </div>

                <div class="sw-container sw-rubrik sw-slide-title sw-mb-2 sw-mr-1 sw-ml-1">{{ component.attributes.title }}</div>

                <div v-if="surveyForm.template === 'survey'" class="sw-survey-container">
                    <template v-if="component.children"
                              v-for="(child,childIndex) of component.children">
                        <component :component="child"
                                   :is="`form-${child.component}`"
                                   :id="child.id"
                                   :title="child.attributes.title"
                                   :left-legend="child.attributes.legendLeft"
                                   :right-legend="child.attributes.legendRight"
                                   :dont-know-legend="child.attributes.dontKnowLegend"
                                   :scala="child.attributes.scala"
                                   @input:checked="checkBox($event)"
                                   :knockout-question="child.attributes.knockout_question"
                                   :knockout-trigger="child.attributes.knockout_trigger"
                                   :weight="child.attributes.weight">
                        </component>
                    </template>
                </div>

                <div v-if="surveyForm.template === 'costsIndicator' && !contactsFirst" class="sw-costsindicator-container">
                    <template v-if="component.children" v-for="(child,childIndex) of component.children">
                        <component :component="child"
                                   :is="`form-${child.component}`"
                                   :id="child.id"
                                   :title="child.attributes.title"
                                   formType="costsIndicator"
                                   @input:checked="checkBox($event)"
                                   :answers="child.settings.answers">
                        </component>
                    </template>
                </div>

                <div v-if="surveyForm.settings&&surveyForm.settings.trackContact&&index === surveyForm.form_components.length - 1"
                     class="sw-container sw-survey-contact-container sw-mb-2 sw-form"
                >
                    <div :class="{'mt-2': surveyForm.template === 'costsIndicator'}">
                        <div class="sw-flex sw-mb-1" v-if="surveyForm.settings.contactFormInfo">
                            <p class="sw-accept sw-pl-1" v-html="surveyForm.settings.contactFormInfo"></p>
                        </div>
                        <component :key="index"
                                   v-for="(component,index) of contactForm.form_components"
                                   :component="component"
                                   @updateContact="$emit('updateContact', {id: $event.id, value: $event.value})"
                                   :is="`form-${component.component}`"
                                   :id="component.id">
                            <component :key="childIndex" v-if="component.children"
                                       v-for="(child,childIndex) of component.children"
                                       :component="child"
                                       @updateContact="$emit('updateContact', {id: $event.id, value: $event.value})"
                                       :is="`form-${child.component}`"
                                       :id="child.id"></component>
                        </component>
                    </div>
                </div>

                <div v-if="surveyForm.template === 'costsIndicator' && contactsFirst" class="sw-costsindicator-container">
                    <template v-if="component.children" v-for="(child,childIndex) of component.children">
                        <component :component="child"
                                   :is="`form-${child.component}`"
                                   :id="child.id"
                                   :title="child.attributes.title"
                                   formType="costsIndicator"
                                   @input:checked="checkBox($event)"
                                   :answers="child.settings.answers">
                        </component>
                    </template>
                </div>

                <template v-if="surveyForm.settings&&surveyForm.settings.trackContact&&index === surveyForm.form_components.length - 1">
                    <div class="sw-mt-2 sw-mr-1">
                        <div class="sw-flex sw-mb-1 sw-align-center">
                            <input  :class="['form-checkbox sw-checkbox', { required: surveyForm.settings.silbitzUser }]"
                                    type="checkbox"
                                    v-model="contactForm.termsAndConditions">
                            <p class="sw-ml-1 sw-accept" v-html="surveyForm.settings.termsAndConditions"></p>
                        </div>
                        <div class="sw-flex sw-mb-1 sw-align-center">
                            <input :class="['form-checkbox sw-checkbox', { required: surveyForm.settings.silbitzUser }]"
                                   type="checkbox"
                                   v-model="contactForm.privacyPolicy">
                            <p class="sw-ml-1 sw-accept" v-html="surveyForm.settings.privacyPolicy"></p>
                        </div>
                        <div class="sw-flex sw-mb-1 sw-align-center">
                            <p class="sw-ml-1 sw-accept" v-html="surveyForm.settings.appendix"></p>
                        </div>
                    </div>
                </template>

                <template v-if="index === surveyForm.form_components.length - 1">
                    <div v-if="cantSubmitText.length" class="sw-flex sw-justify-end sw-container">
                        <p class="sw-bad">{{ cantSubmitText }}</p>
                    </div>
                    <div
                        class="sw-justify-end sw-container sw-mt-2">
                        <button type="button" v-if="currentStep !== 0" @click="currentStep--; scrollMeTo('sw-anchor')"
                                class="sw-btn sw-flex sw-justify-end sw-float-left">
                            ZURÜCK
                        </button>
                        <button type="button"
                                :class="{'opacity-50': checked < questionsLength}"
                                @click="submit()"
                                class="sw-disabled-button sw-btn sw-flex sw-justify-end sw-float-right">
                            <template v-if="surveyForm.settings&&surveyForm.settings.silbitzUser">
                                Angebot anfordern
                            </template>
                            <template v-else>Auswertung generieren</template>
                        </button>
                    </div>
                </template>

                <template v-else>
                    <div v-if="cantNextText.length" class="sw-flex sw-justify-end sw-container">
                        <p class="sw-bad">{{ cantNextText }}</p>
                    </div>
                    <div class="sw-justify-end sw-container sw-mt-2">
                        <button v-if="currentStep !== 0"
                                @click="back()"
                                type="button"
                                class="sw-btn sw-flex sw-justify-end sw-float-left">
                            ZURÜCK
                        </button>
                        <button type="button" @click="next()"
                                class="sw-disabled-button sw-btn sw-flex sw-justify-end sw-float-right">
                            WEITER
                        </button>
                    </div>
                </template>
            </div>
        </template>
        <slot></slot>
    </div>
</template>

<script>
import FormScalaQuestion from "@/Pages/Forms/Partials/ScalaQuestion.vue";
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import PublicView from "@/Pages/Forms/PublicView.vue";
import FormCheckbox from "@/Pages/Forms/Partials/Checkbox.vue";
import FormColumn from "@/Pages/Forms/Partials/Column.vue";
import FormInput from "@/Pages/Forms/Partials/Input.vue";
import FormDate from "@/Pages/Forms/Partials/Date.vue";
import Form from "@/Pages/Forms/Partials/Form.vue";
import FormTextarea from "@/Pages/Forms/Partials/Textarea.vue";
import FormSelect from "@/Pages/Forms/Partials/Select.vue";
import FormButton from "@/Pages/Forms/Partials/Button.vue";
import FormMultipleChoice from "@/Pages/Forms/Partials/MultipleChoice.vue";

export default {
    name: "Slide",
    props: {
        surveyForm: {},
        contactForm:{}
    },
    components: {
        PublicView,
        FormScalaQuestion,
        StepProgress,

        FormCheckbox,
        FormColumn,
        FormInput,
        FormDate,
        Form,
        FormTextarea,
        FormSelect,
        FormButton,
        FormMultipleChoice
    },
    data() {
        return {
            currentStep: 0,
            checked: {},
            cantNextText:'',
            cantSubmitText:'',
            contactData: {}
        }
    },
    computed: {
        questionsLength() {
            return this.surveyForm.form_components.reduce((acc, curr) => acc + curr.children.length, 0);
        },
        canSubmit() {
            if (this.surveyForm.settings.trackContact) {
                return this.contactForm.termsAndConditions && this.contactForm.privacyPolicy&&this.canNext();
            }else{
                return this.canNext();
            }
        },
        contactsFirst() {
            return this.surveyForm?.settings?.contactsFirst === true;
        }
    },
    methods: {
        fillForm(ev) {
            if (!Object.keys(this.contactData).includes(ev.id)) {
                this.$set(this.contactData, ev.id, ev.value);
                this.$forceUpdate();
            } else {
                this.contactData[ev.id] = ev.value;
                this.$forceUpdate();
            }
        },
        submit() {
            const canSubmit = this.surveyForm.settings.silbitzUser
                ? this.canSubmitSilbitz()
                : this.canSubmit;

            if(canSubmit) {
                return this.$emit('submit');
            }
            this.cantSubmitText = 'Einige der Fragen wurden nicht beantwortet oder die Datenschutzerklärung wurde nicht ausgewählt.'
            setTimeout(() => {
                this.cantSubmitText = ''
            }, 5000)
        },
        scrollMeTo(id) {
            let el=document.getElementById(id)
            el.scrollIntoView()
            window.scrollBy(0,-500)
        },
        next() {
            if (this.canNext()) {
                this.currentStep++;
                return this.scrollMeTo('sw-anchor')
            }
            this.cantNextText = 'Einige der Fragen wurden nicht beantwortet.'
            setTimeout(() => {
                this.cantNextText = ''
            }, 5000)
        },
        back() {
            this.currentStep--
            this.scrollMeTo('sw-anchor')
        },
        checkBox(ev){
            this.$emit('updateSurvey', {id: ev.id, value: ev.value});
            if (Object.hasOwn(this.checked,this.currentStep)) {
                this.$set(this.checked,''+this.currentStep,this.checked[this.currentStep]+1);
                return;
            }
            this.$set(this.checked,''+this.currentStep,1);
        },
        canNext() {
            let length = this.surveyForm.form_components[this.currentStep].children.length;
            if (Object.hasOwn(this.checked, this.currentStep)) {
                return this.checked[this.currentStep] >= length;
            }
            return false
        },
        canSubmitSilbitz() {
            const requiredFields = document.querySelectorAll('.required');
            let allValid = true;
            console.log('requiredFields', requiredFields);

            requiredFields.forEach(field => {
                const isCheckbox = field.type === 'checkbox';
                const isValid = isCheckbox ? field.checked : field.value && field.value.trim() !== '';

                if (!isValid) {
                    field.classList.add('sw-error');
                    allValid = false;
                } else {
                    field.classList.remove('sw-error');
                }
            });

            return allValid;

            // for (let field of requiredFields) {
            //     if (field.type === 'checkbox') {
            //         if (!field.checked) {
            //             return false;
            //         }
            //     }
            //     else if (!field.value || field.value.trim() === '') {
            //         return false;
            //     }
            // }
            // return true;
        }
    }
}
</script>

<style lang="sass">
button[disabled=disabled].sw-disabled-button
    border: 1px solid red

.progressbar
    .step-progress__wrapper
        z-index: 0

    .step-progress__step
        &:after
            height: 38px
            width: 38px

        span, .fa-check
            font-size: 20px

    .step-progress__step-label
        display: none

.sw-flex
    display: flex

.sw-justify-end
    justify-content: end

.sw-justify-start
    justify-content: start

.sw-justify-between
    justify-content: space-between

.sw-input
    border-radius: 8px
    border: 1px solid lightgray

.sw-input-container-50
    display: grid
    width: 50%

.sw-input-container-100
    display: grid
    width: 100%

.sw-mr-1
    margin-right: 10px

.sw-ml-1
    margin-left: 10px

.sw-mr-2
    margin-right: 20px

.sw-ml-2
    margin-left: 20px

.sw-mb-1
    margin-bottom: 10px

.sw-mt-1
    margin-top: 10px

.sw-mb-2
    margin-bottom: 20px

.sw-mt-2
    margin-top: 20px


.sw-btn
    cursor: pointer
    border: 1px solid lightgrey
    padding: 10px 20px
    border-radius: 8px
    background-color: white
    font-size: 14px
    font-weight: normal

.sw-bad
    color:  red

.sw-float-right
    float: right

.sw-float-left
    float: left

.sw-flex-grow
    flex-grow: 1

.sw-index
    font-weight: bold

.sw-rubrik
    color: gray
    font-weight: 700
    font-size: 22px

.sw-form
    label
        margin-bottom: 0px
        margin-top: 10px

.sw-accept
    font-size: 16px

    @media (max-width: 767px)
        font-size: 12px

.sw-checkbox
    align-items: start
    margin-top: 2px

.sw-error
    border: 1px solid red !important
</style>
